import React, {createContext, useState, useEffect, useContext, useRef} from 'react';
import WebSocketService from "../../../websockets/WebSocketService";
import {tickStorage} from "@dashboard/contexts/tickStore";
import isEqual from 'lodash.isequal';

const DelayedTickContext = createContext();

export const useDelayedTickContext = () => useContext(DelayedTickContext);

export const DelayedTickProvider = ({ instrumentToken, children }) => {
    const [delayedTick, setDelayedTick] = useState({});
    /*const { delayedTicks,updateTicks } = useDelayedTickSharingContext(); // Get real-time ticks*/
    /*const { updateTicks } = useDelayedTickSharingContext(); // Get real-time ticks*/

    const updateTicks = (incomingTick) => {
        tickStorage.latest = {
            ...tickStorage.latest,
            [incomingTick.instrumentToken]: incomingTick
        };
    };

    useEffect(() => {
        const interval = setInterval(() => {
            const latest = tickStorage.latest[instrumentToken];
            if (latest) {
                setDelayedTick(prev =>
                    isEqual(prev, latest) ? prev : { ...latest }
                );
            }
        }, 10000); // pull every 10 seconds

        return () => clearInterval(interval);
    }, [instrumentToken]);

    /*useEffect(() => {
        const tick = delayedTicks?.[instrumentToken];
        setDelayedTick(prev => {
            if (!tick || JSON.stringify(prev) === JSON.stringify(tick)) return prev;
            return { ...tick };
        });
    }, [instrumentToken, delayedTicks[instrumentToken]]);
*/

    const handleTickUpdate = (message) => {
        if (message.type === 'tickData') {
            const incomingTick = message.data;

            // Update single tick (for GUIInstrumentRow)
            if (incomingTick.instrumentToken === instrumentToken) {
                //console.log("incomingTick:", incomingTick);
                updateTicks(incomingTick);
            }
        }
    };

    useEffect(() => {
        // Log the subscription with uniqueId
        /*if(instrumentToken===36865){
            console.log(`Subscribing to WebSocket for instrumentToken: ${instrumentToken}, uniqueId: ${uniqueId}`);
        }*/
        WebSocketService.subscribe('tickData', instrumentToken, handleTickUpdate);

        return () => {
            // Log the unsubscription with uniqueId
            /*if(instrumentToken===36865) {
                console.log(`Unsubscribing from WebSocket for instrumentToken: ${instrumentToken}, uniqueId: ${uniqueId}`);
            }*/
            WebSocketService.unsubscribe('tickData', instrumentToken, handleTickUpdate);
        };
    }, [instrumentToken]); // Add uniqueId as a dependency

    return (
        <DelayedTickContext.Provider value={{ delayedTick }}>
            {children}
        </DelayedTickContext.Provider>
    );
};
